const tsDataReading = {
  scale1: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale2: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale3: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale4: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale5: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale6: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale7: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale8: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale9: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale10: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale11: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale12: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale13: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale14: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale15: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale16: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale17: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale18: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale19: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale20: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale21: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale22: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale23: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale24: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale25: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale26: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale27: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale28: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale29: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale30: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale31: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale32: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale33: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale34: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale35: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  scale36: {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.03991747
  }
}

export default tsDataReading
